import { useState } from 'react';
import axios from 'axios';

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/user/forgot-password`, { email });
      setMsg("Un email contenant un lien de réinitialisaion a été envoyé sur votre boîte mail.");
    } catch (err) {
      setMsg("Erreur.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Saisissez l'adresse mail de votre compte : </h3>
      <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Votre email" />
      <button type="submit">Envoyer</button>
      <p>{msg}</p>
    </form>
  );
}
